import api from './api';

export const helperService = {
  getAll: async (params = {}) => {
    const response = await api.get('/helpers', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/helpers/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/helpers', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/helpers/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/helpers/${id}`);
    return response.data;
  },
};

export default helperService;
